import React from "react";
import Layout from "../../Layouts/Layout";
import ServiceWorldInitialCase from "../../../components/Serviceworld/ServiceWorldInitialCase";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

const ServiceWorldInitialCasePage = () => {
  return (
    <LayoutAuthenticated>
      <ServiceWorldInitialCase />
    </LayoutAuthenticated>
  );
};

export default ServiceWorldInitialCasePage;
